import React, { Component } from "react";
import { Row, Col, Menu, Select, Button, Layout, Slider, Icon } from "antd";
import Dog from "./components/Dog";
import DogsTable from "./dogs";
import { makeFirstLetterUppercase } from "./utils";
import "./App.css";
const DogsIDs = Object.keys(DogsTable);
const Option = Select.Option;
const des = `This dog is probably one of your favorites ;)`;
class App extends Component {
  state = {
    dog1: DogsIDs[Math.floor(Math.random() * DogsIDs.length)],
    dog2: DogsIDs[Math.floor(Math.random() * DogsIDs.length)],
    show: false,
    transitionslider: 4,
    transitioncounter: 1,
    sliderstarted: false,
  };

  handleDogChange = (name) => (value) => {
    this.setState({ [name]: value });
  };

  handleDogSliderChange = (val) => {
    this.setState({ transitionslider: val });
  };

  showResult = () => {
    this.setState({ show: true });
    this.playDogTransition();
    setTimeout(()=>{window.location.href = "#result"},1000)
    
  };

  tryAgain = () => {
    this.setState({ dog1: "", dog2: "", show: false });
  };

  shuffle = () => {
    this.setState({
      dog1: DogsIDs[Math.floor(Math.random() * DogsIDs.length)],
      dog2: DogsIDs[Math.floor(Math.random() * DogsIDs.length)],
      show: false,
    });
  };

  playDogTransition = () => {
    if (this.state.sliderstarted) {
      console.log("Stopping slider");
      clearInterval(this.intervalID);
      this.setState({ sliderstarted: false });
    } else {
      this.setState({ sliderstarted: true });
      console.log("Starting");
      this.intervalID = setInterval(() => {
        this.slidertick();
      }, 250);
    }
  };

  slidertick() {
    const tickval = this.state.transitionslider;
    if (tickval === 0) {
      this.setState({ transitioncounter: +1 });
    }
    if (tickval === 7) {
      this.setState({ transitioncounter: -1 });
    }
    this.setState({ transitionslider: tickval + this.state.transitioncounter });
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  render() {
    const { dog1, dog2, show, transitionslider } = this.state;

    return (
      <div className="App">
        <Layout.Header style={{  width: "100%" }}>
          <div className="logo">Need4Breed</div>
          <Menu
            className="top-nav"
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={["2"]}
            style={{ lineHeight: "64px" }}
          >
            <Menu.Item key="1">Dog breeder</Menu.Item>
            <Menu.Item key="2">Dog art</Menu.Item>
            <Menu.Item key="3">Dog quiz</Menu.Item>
          </Menu>
        </Layout.Header>
        <div className="dog-breeder">
          <div className="white-bg">
            <Row style={{ paddingBottom: "15px" }}>
              <Col span={24}>
                <h1>Breed your crossbreed with machine learning</h1>
                <h3>
                  Have you ever wondered how a crossbreed of your two favorite
                  dogs would look like?
                </h3>
              </Col>
            </Row>
            <Row  justify="center" type="flex">
              <Col  xs={24} sm={12} md={6} lg={5} xl={4}>
                <Button onClick={this.showResult} disabled={!(dog1 && dog2)}>
                  Show me the crossbreed!
                </Button>
              </Col>
              <Col  xs={24} sm={12} md={6} lg={5} xl={4}>
                <Button onClick={this.shuffle}>Shuffle!</Button>
              </Col>
            </Row>
            {show && (
              <div className="result-bg">
              <Row justify="space-around" type="flex">
              <Col  xs={24} md={24} lg={10}>
              <div id="result"></div>
                  <Dog
                    title="Here is your crossbreed:"
                    image={`https://s3.eu-central-1.amazonaws.com/crossbreeddog-production/${DogsTable[dog1].Filename.replace(
                      / /g,
                      "%20"
                      )}_${DogsTable[dog2].Filename.replace(
                        / /g,
                        "%20"
                        )}-crossbreed_${transitionslider}.jpg`}
                        description={`This is the unique crossbreed of ${
                          (dog1 && makeFirstLetterUppercase(DogsTable[dog1].Name).split(",")[0]) ||
                          "dog 1"
                        } and ${
                          (dog2 && makeFirstLetterUppercase(DogsTable[dog2].Name).split(",")[0]) ||
                          "dog 2"
                        }`}
                        />
                        </Col>
                </Row>
                <Row>
                  <Col xs={2} sm={4} md={6} lg={8} xl={10}></Col>
                  <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                    {this.state.sliderstarted ? (
                      <Icon
                        type="pause"
                        onClick={this.playDogTransition.bind(this)}
                      />
                    ) : (
                      <Icon
                        type="caret-right"
                        onClick={this.playDogTransition.bind(this)}
                      />
                    )}
                    <Slider
                      defaultValue={4}
                      min={0}
                      max={7}
                      value={this.state.transitionslider}
                      onChange={this.handleDogSliderChange}
                    />
                  </Col>
                  <Col xs={2} sm={4} md={6} lg={8} xl={10}></Col>
                </Row>
                <Row justify="center" type="flex">
                  <Col className="m-b-50" xs={24} sm={12} md={6} lg={4} xl={3}>
                    <Button onClick={this.tryAgain}>Try again!</Button>
                  </Col>

                  <Col className="m-b-50" xs={24} sm={12} md={6} lg={4} xl={3}>
                    <Button><a href="mailto:fkrekeler+dog@gmail.com">Report!</a></Button>
                  </Col>
                  
                </Row>
              </div>
            )}
            <Row gutter={20}>
              <Dog
                title={`Dog 1: ${
                  (dog1 && makeFirstLetterUppercase(DogsTable[dog1].Name).split(",")[0]) || ""
                }`}
                colProps={{ xs: 24, sm: 12, lg: { offset: 4, span: 8 } }}
                image={`https://s3.eu-central-1.amazonaws.com/crossbreeddog-production/${DogsTable[dog1].Filename.replace(
                  / /g,
                  "%20"
                )}_${DogsTable[dog2].Filename.replace(/ /g, "%20")}-crossbreed_0.jpg`}
                description={DogsTable[dog1].Text}
              >
                <Select
                  value={DogsTable[dog1].Filename}
                  onChange={this.handleDogChange("dog1")}
                  style={{ width: "100%" }}
                >
                  {DogsIDs.map((id) => (
                    <Option value={DogsTable[id].Filename} key={id}>
                      {makeFirstLetterUppercase(DogsTable[id].Name)}
                    </Option>
                  ))}
                </Select>
              </Dog>
              <Dog
                title={`Dog 2: ${
                  (dog2 && makeFirstLetterUppercase(DogsTable[dog2].Name).split(",")[0]) || ""
                }`}
                colProps={{ xs: 24, sm: 12, lg: 8 }}
                image={`https://s3.eu-central-1.amazonaws.com/crossbreeddog-production/${DogsTable[dog1].Filename.replace(
                  / /g,
                  "%20"
                )}_${DogsTable[dog2].Filename.replace(/ /g, "%20")}-crossbreed_7.jpg`}
                description={DogsTable[dog2].Text || des}
              >
                <Select
                  value={DogsTable[dog2].Filename}
                  onChange={this.handleDogChange("dog2")}
                  style={{ width: "100%" }}
                >
                    {DogsIDs.map((id) => (
                    <Option value={DogsTable[id].Filename} key={id}>
                      {makeFirstLetterUppercase(DogsTable[id].Name)}
                    </Option>
                  ))}
                </Select>
              </Dog>
            </Row>
            <Row>
              <Col className="m-b-50">
                <Button onClick={this.showResult} style={{marginBottom:"20px"}} disabled={!(dog1 && dog2)}>
                  Show me the crossbreed!
                </Button>
              </Col>
            </Row>
          </div>

          <Row className="p-t-15">
            <Col xs={24} sm={24} md={5} lg={5} className="p-l-70">
              <h5>franz.media</h5>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8}>
              <h5>Made with ML and dog love</h5>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default App;
